(function ($) {
    var $el = $('[data-modal]');
    if($el.length > 0) {
        $el.on('click', function() {
            $($(this).data('target')).overlay($(this));
        });
    }
}(jQuery));



// WEBPACK FOOTER //
// ./src/app/components/overlay/overlay.js